export default __webpack_public_path__ + "static/18-4406302fdb53452b5984cbdede027245.jpg";